import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that checks if the current URL path corresponds to a company page
 * Company URLs follow the pattern: /firms/:firmSlugParam/companies/:companySlugParam/:tableSlugParam
 * 
 * @returns {boolean} True if the current path is a company path, false otherwise
 */
export const useIsCompanyPath = (): boolean => {
  const location = useLocation();

  const isCompanyPath = useMemo(() => location.pathname.includes('/companies/'), [location.pathname]);

  return isCompanyPath;
};
